module.exports = __webpack_public_path__ + "static/media/FlightBriefing Promo 2024.72d8fe30.pdf";